import { render } from "./TeacherCarousel.vue?vue&type=template&id=082c2838&scoped=true&ts=true"
import script from "./TeacherCarousel.vue?vue&type=script&lang=ts"
export * from "./TeacherCarousel.vue?vue&type=script&lang=ts"

import "./TeacherCarousel.vue?vue&type=style&index=0&id=082c2838&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082c2838"]])

export default __exports__